import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=2d4e6e90&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=2d4e6e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e6e90",
  null
  
)

export default component.exports